export interface ColorTheme {
  name: string;
  primary: string;
  background: string;
}

export const COLOR_THEMES: Record<string, ColorTheme> = {
  // blue: { name: 'Blue', primary: '#2C5EF5', background: '#2C5EF5' },   
  cool: { name: 'Cool', primary: '#2AB2FA', background: '#2AB2FA' },
  // dark: { name: 'Dark', primary: '#000000', background: '#000000' },
  green: { name: 'Green', primary: '#4CAF50', background: '#4CAF50' },
  warm: { name: 'Warm', primary: '#FF5924', background: '#FF5924' },
  purple: { name: 'Purple', primary: '#4748C5', background: '#4748C5' },
  red: { name: 'Red', primary: '#D3302F', background: '#D3302F' },
  teal: { name: 'Teal', primary: '#19B2E6', background: '#19B2E6' },
  orange: { name: 'Orange', primary: '#FF7700', background: '#FF7700' }
}; 